import { Component, OnInit } from '@angular/core';
import { UrlConstants } from 'src/app/constants/url-constants';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { GenericAPIService } from 'src/app/services/generic-api.service';
import { NotificationConstants } from 'src/app/constants/notification-constants';
import { EncryptDecryptLocalStorageService } from 'src/app/services/encrypt-decrypt-localStorage.service';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';
import {NgbTimepickerConfig} from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

// Custom validator for time picker
function timeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Don't validate empty values, let required validator handle that
    }
    
    const time = control.value;
    const hour = time.hour;
    const minute = time.minute;
    
    // Validate hour (0-23)
    if (hour === null || hour === undefined || isNaN(hour) || hour < 0 || hour > 23) {
      return { invalidHour: { value: hour } };
    }
    
    // Validate minute (0-59)
    if (minute === null || minute === undefined || isNaN(minute) || minute < 0 || minute > 59) {
      return { invalidMinute: { value: minute } };
    }
    
    return null;
  };
}

@Component({
  selector: 'app-race-result',
  templateUrl: './race-engine.component.html',
  styleUrls: ['./race-result.component.scss']
})
export class RaceResultComponent implements OnInit {
  public getRaceResultUrl = UrlConstants.getRaceResult;
  public currentYearRaceInfo = UrlConstants.racesUrl;
  public getCircuitListUrl = UrlConstants.getCircuitList;
  public saveRaceUrl = UrlConstants.saveRace;
  public comminSoonMsg = NotificationConstants.comminSoonMsg;
  public saveRaceScheduleUrl = UrlConstants.saveRaceSchedule;
  public updateCircuitUrl = UrlConstants.updateCircuit;
  public addRaceForm: FormGroup;
  public myDatePickerOptions: IMyDpOptions;
  public myStartDatePickerOptions: IMyDpOptions;
  public myEndDatePickerOptions: IMyDpOptions;
  public raceResultList = [];
  public races = [];
  public circuitList = [];
  public message = '';
  public PreLoader: boolean = false;
  public upcomingRaceId: any;
  public entryClosed: boolean = false;
  public endDate;
  public today;
  // public successMessage: any;
  // public failureMessage: any;
  public showAddRaceEngineButton: boolean = false;
  public editCircuitForm: FormGroup;
  public editStartDateForm: FormGroup;
  public editEndDateForm: FormGroup;
  public updateRaceEntryDate=UrlConstants.updateRaceEntryDate;
  PreLoaderList: boolean = false;
 
  constructor(public genericService: GenericAPIService, public encryptDecryptLocalStorageService: EncryptDecryptLocalStorageService, 
    public encryptDecryptService: EncryptDecryptService,
    config: NgbTimepickerConfig) {
    this.today = new Date(this.encryptDecryptLocalStorageService.getLocalStorage("todayDate"));
    this.createAddRaceForm();
    this.today.setFullYear(this.today.getFullYear());
    this.myDatePickerOptions = {
      dateFormat: 'yyyy-mm-dd',
      disableSince: { year: this.today.getFullYear(), month: 12, day: 31 },
      disableUntil: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() - 1 },
      showClearDateBtn: false,
      editableDateField: false,
      openSelectorOnInputClick: true
    };
    this.myStartDatePickerOptions = {
      dateFormat: 'yyyy-mm-dd',
      showClearDateBtn: false,
      editableDateField: false,
      openSelectorOnInputClick: true
    };
    this.myEndDatePickerOptions = {
      dateFormat: 'yyyy/mm/dd',
      showClearDateBtn: false,
      editableDateField: false,
      openSelectorOnInputClick: true
    };
    config.readonlyInputs = false; // Allow users to type time values directly
  }
  ngOnInit() {
    this.getRacesInfo();
    this.createEditCircuitForm();
    this.createEditStartDateForm();
    this.createEditEndDateForm();
  }
  createAddRaceForm() {
    this.addRaceForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      circuitId: new FormControl('', [Validators.required]),
      round: new FormControl('', [Validators.required, Validators.pattern(/^[1-9][0-9]*$/)]),
      year: new FormControl('', [Validators.required]),
      time: new FormControl('', [Validators.required, timeValidator()]),
      isSprintEntry:new FormControl(false),
    })
    this.onChanges();
  }
  onChanges(): void {
    this.addRaceForm.get('time').valueChanges.subscribe(val => {
    });
  }
  createEditCircuitForm() {
    this.editCircuitForm = new FormGroup({
      circuitId: new FormControl('', [Validators.required]),
      raceId: new FormControl('', [Validators.required]),
    })
  }
  createEditStartDateForm() {
    this.editStartDateForm = new FormGroup({
      startDate: new FormControl('', [Validators.required]),
      startTime: new FormControl('', [Validators.required, timeValidator()]),
      raceId: new FormControl('', [Validators.required]),
    })
  }
  createEditEndDateForm() {
    this.editEndDateForm = new FormGroup({
      endDate: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required, timeValidator()]),
      raceId: new FormControl('', [Validators.required]),
    })
  }
  //append with position like st,nd,rd,th
  getposition(position) {
    if (position == 1) {
      return position + "st";
    }
    else if (position == 2) {
      return position + "nd";
    }
    else if (position == 3) {
      return position + "rd";
    }
    return position + "th";
  }

  getRaceMode(race) {
    var raceDate = new Date(race.RaceResult.date);
    var nextRaceDate = race.nextRaceDate ? new Date(race.nextRaceDate):race.nextRaceDate;
    //var nextDayOfRace = new Date(raceDate);
    //nextDayOfRace.setDate(nextDayOfRace.getDate() + 1);
    if (this.today >= raceDate && (this.today < nextRaceDate || nextRaceDate==null )) {
      return "update";
    }
    else if (raceDate < this.today && race.hasRaceResult == true) {
      return "updated";
    }
    else {
      return "notUpdated";
    }
  }

  addRaceEngine() {
    this.PreLoaderList = true;
    this.genericService.post(this.saveRaceScheduleUrl, "").subscribe(response => {
      if (response.status.success == "Success") {
        this.getRacesInfo();
        this.PreLoaderList = false;
      } else if (response.status.success == "Failure") {
        this.PreLoaderList = false;
      } else {
        this.PreLoaderList = false;
      }
    }, error => {
      this.PreLoaderList = false;
    })
  }

  getRacesInfo() {
    this.PreLoaderList = true;
    this.genericService.getAll(this.currentYearRaceInfo).subscribe(response => {
      if(response.status.success=="Success"){
      this.races = response.data;
      this.PreLoaderList = false;
      if (this.races.length > 0) {
        this.showAddRaceEngineButton = false;
        for (let race of this.races) {
          race.mode = this.getRaceMode(race);
          race.modeForDriver = this.getDriverMode(race);
          race.isUpdate = this.isUpdate(race);
          race.isPredictionViewable = this.isPredictionViewable(race);
        }
      }
      //  else {
      //   this.showAddRaceEngineButton = true;
      // }
    }
    else{
      // this.races=[];
      this.showAddRaceEngineButton = true;
      this.PreLoaderList = false;
    }
  })
    
  }

isUpdate(race) {
  const raceEndDateAndTime = new Date(race.RaceResult.date);
  const now = new Date();

  return now < raceEndDateAndTime ? "update" : "updated";
}
  getDriverMode(race) {
    var RaceStartDate = new Date(race.RaceStartDate);
    if (RaceStartDate > this.today) {
      return "update";
    }
    else {
      return "updated";
    }
  }

  isPredictionViewable(race) {
    if (race.raceEntryDates && race.raceEntryDates.raceEntryEndDate) {
      const raceEndDateAndTime = new Date(race.raceEntryDates.raceEntryEndDate);
      const now = new Date();
      return now > raceEndDateAndTime;
    }
    return false;
  }

  getCircuitListInfo() {
    this.genericService.getAll(this.getCircuitListUrl).subscribe(response => {
      this.circuitList = response.data;
    })
  }

  restrictTimeInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    if (input && input.tagName === 'INPUT') {
      const isHour = input.placeholder === 'HH' || input.getAttribute('aria-label') === 'Hours';
      const isMin = input.placeholder === 'MM' || input.getAttribute('aria-label') === 'Minutes';
      
      // Only handle numeric keys
      if (/^[0-9]$/.test(event.key)) {
        const selectionStart = input.selectionStart;
        const selectionEnd = input.selectionEnd;
        const currentVal = input.value;
        const newVal = currentVal.slice(0, selectionStart) + event.key + currentVal.slice(selectionEnd);
        
        const maxVal = isHour ? 23 : 59;
        if (parseInt(newVal) > maxVal) {
          event.preventDefault();
        }
      }
    }
  }

  showNotification() {
    this.message = this.comminSoonMsg;
    setTimeout(() => {
      this.message = ''
    }, 4000);
  }

  viewRacePredictions(race) {
    this.genericService.router.navigate(['/admin/adminRacePrediction'], {
      queryParams: {
        raceId: race.RaceResult.raceId,
        raceName: race.RaceResult.name,
        raceResultId: race.raceResultId
      }
    });
  }
  getRaceResult() {
    this.genericService.getAll(this.getRaceResultUrl).subscribe(response => {
      this.raceResultList = response.data;
    })
  }

  saveRace() {
    this.PreLoader = true;
    console.log(this.addRaceForm);
    if (this.addRaceForm.valid) {
      var payload = {
        "year": `${this.addRaceForm.value.year.date.year}`,
        "round": this.addRaceForm.value.round,
        "name": this.addRaceForm.value.name,
        "date": this.addRaceForm.value.year.formatted,
        "time": `${this.addRaceForm.value.time.hour}:${this.addRaceForm.value.time.minute}:00`,
        "isSprintEntry":this.addRaceForm.value.isSprintEntry,
        "circuits": {
          "circuitId": this.addRaceForm.value.circuitId
        }
      }
      this.PreLoader = true;
      this.genericService.post(this.saveRaceUrl, payload).subscribe(response => {
        if (response.status.success == "Success" || response.status.success == "SUCCESS") {
          this.getRacesInfo();
          this.PreLoaderList = true;
          $("#addRace").modal("hide");
          //  this.successMessage = response.status.message;
          this.PreLoader = false
          this.addRaceForm.reset();
        }
        else {
          //   this.failureMessage = response.status.message;
          this.PreLoader = false
        }
        // setTimeout(() => {
        //   this.successMessage = undefined;
        //   this.failureMessage = undefined;
        // }, 2000);
      })
    }
  }

  closeRaceModal() {
    $("#addRace").modal("hide");
    this.addRaceForm.reset();
  }

  editCircuit(raceobj) {
    this.getCircuitListInfo();
    $("#editCircuit").modal("show");
    this.editCircuitForm.controls['circuitId'].setValue(raceobj.circuits.circuitId);
    this.editCircuitForm.controls['raceId'].setValue(raceobj.raceId);
  }

  closeEditCircuitModal() {
    $("#editCircuit").modal("hide");
    this.editCircuitForm.reset();
  }

  saveCircuit() {
    if (this.editCircuitForm.valid) {
      this.PreLoader = true;
      this.genericService.post(this.updateCircuitUrl + "?raceId=" + this.editCircuitForm.value.raceId + "&circuitId=" + this.editCircuitForm.value.circuitId, "").subscribe(response => {
        if (response.status.success == "Success" || response.status.success == "Sucess") {
          //   this.successMessage = response.status.message;
          $("#editCircuit").modal("hide");
          this.editCircuitForm.reset();
          this.getRacesInfo();
          this.PreLoaderList = true;
          this.PreLoader = false;
        } else if (response.status.success == "Fail") {
          // this.failureMessage = response.status.message;
          this.PreLoader = false;
        } else {
          //  this.failureMessage = response.status.message;
          this.PreLoader = false
        }
        // setTimeout(() => {
        //   this.successMessage = undefined;
        //   this.failureMessage = undefined;
        // }, 2000);

      }, error => {
        this.PreLoader = false;
      })
    }
  }
  addingSprintEntery(race:any){
    this.encryptDecryptService.setToLocalStorage("isSprintEntry", race.RaceResult.isSprintEntry);
  }

  editStartDate(raceobj) {
    $("#editStartDate").modal("show");
    // Parse the existing date and time if available
    if (raceobj.raceEntryDates && raceobj.raceEntryDates.raceEntryStartDate) {
      const dateTimeStr = raceobj.raceEntryDates.raceEntryStartDate;
      
      // Check if it contains time (format: "YYYY-MM-DD HH:MM:SS" or "YYYY-MM-DD HH:MM")
      const parts = dateTimeStr.split(' ');
      const dateStr = parts[0];
      const dateParts = dateStr.split('-');
      
      if (dateParts.length === 3) {
        this.editStartDateForm.controls['startDate'].setValue({
          date: {
            year: parseInt(dateParts[0]),
            month: parseInt(dateParts[1]),
            day: parseInt(dateParts[2])
          },
          formatted: dateStr
        });
      }
      
      // Parse time if available
      if (parts.length > 1) {
        const timeStr = parts[1];
        const timeParts = timeStr.split(':');
        if (timeParts.length >= 2) {
          this.editStartDateForm.controls['startTime'].setValue({
            hour: parseInt(timeParts[0]),
            minute: parseInt(timeParts[1])
          });
        }
      } else {
        // Set default time if not available
        this.editStartDateForm.controls['startTime'].setValue({
          hour: 0,
          minute: 0
        });
      }
    }
    this.editStartDateForm.controls['raceId'].setValue(raceobj.raceId);
  }

  closeEditStartDateModal() {
    $("#editStartDate").modal("hide");
    this.editStartDateForm.reset();
  }

  saveStartDate() {
    if (this.editStartDateForm.valid) {
      this.PreLoader = true;
      // Combine date and time
      const dateStr = this.editStartDateForm.value.startDate.formatted;
      const timeObj = this.editStartDateForm.value.startTime;
      const timeStr = `${String(timeObj.hour).padStart(2, '0')}:${String(timeObj.minute).padStart(2, '0')}:00`;
      const dateTimeStr = `${dateStr} ${timeStr}`;
      
      const payload = {
        raceId: this.editStartDateForm.value.raceId,
        raceEntryStartDate: dateTimeStr
      };
      
      // API call to update start date
      this.genericService.put(this.updateRaceEntryDate, payload).subscribe(response => {
        if (response.status.success == "Success") {
          $("#editStartDate").modal("hide");
          this.editStartDateForm.reset();
          this.getRacesInfo();
          this.PreLoaderList = true;
          this.PreLoader = false;
        } else {
          this.PreLoader = false;
        }
      }, error => {
        this.PreLoader = false;
      });
    }
  }

  editEndDate(raceobj) {
    const raceDate = new Date(raceobj.date);
    this.myEndDatePickerOptions = {
      dateFormat: 'yyyy/mm/dd',
      showClearDateBtn: false,
      editableDateField: false,
      openSelectorOnInputClick: true,
      disableSince: {
        year: raceDate.getFullYear(),
        month: raceDate.getMonth() + 1,
        day: raceDate.getDate()
      }
    };
    $("#editEndDate").modal("show");
    // Parse the existing date and time if available
    if (raceobj.raceEntryDates && raceobj.raceEntryDates.raceEntryEndDate) {
      const dateTimeStr = raceobj.raceEntryDates.raceEntryEndDate;
      
      // Check if it contains time (format: "YYYY-MM-DD HH:MM:SS" or "YYYY-MM-DD HH:MM")
      const parts = dateTimeStr.split(' ');
      const dateStr = parts[0];
      const dateParts = dateStr.split('-');
      
      if (dateParts.length === 3) {
        this.editEndDateForm.controls['endDate'].setValue({
          date: {
            year: parseInt(dateParts[0]),
            month: parseInt(dateParts[1]),
            day: parseInt(dateParts[2])
          },
          formatted: dateStr
        });
      }
      
      // Parse time if available
      if (parts.length > 1) {
        const timeStr = parts[1];
        const timeParts = timeStr.split(':');
        if (timeParts.length >= 2) {
          this.editEndDateForm.controls['endTime'].setValue({
            hour: parseInt(timeParts[0]),
            minute: parseInt(timeParts[1])
          });
        }
      } else {
        // Set default time if not available
        this.editEndDateForm.controls['endTime'].setValue({
          hour: 23,
          minute: 59
        });
      }
    }
    this.editEndDateForm.controls['raceId'].setValue(raceobj.raceId);
  }

  closeEditEndDateModal() {
    $("#editEndDate").modal("hide");
    this.editEndDateForm.reset();
  }

  saveEndDate() {
    if (this.editEndDateForm.valid) {
      this.PreLoader = true;
      // Combine date and time
      const dateStr = this.editEndDateForm.value.endDate.formatted;
      const timeObj = this.editEndDateForm.value.endTime;
      const timeStr = `${String(timeObj.hour).padStart(2, '0')}:${String(timeObj.minute).padStart(2, '0')}:00`;
      const dateTimeStr = `${dateStr} ${timeStr}`;
      
      const payload = {
        raceId: this.editEndDateForm.value.raceId,
        raceEntryEndDate: dateTimeStr
      };
      
      // API call to update end date
      this.genericService.put(this.updateRaceEntryDate, payload).subscribe(response => {
        if (response.status.success == "Success") {
          $("#editEndDate").modal("hide");
          this.editEndDateForm.reset();
          this.getRacesInfo();
          this.PreLoaderList = true;
          this.PreLoader = false;
        } else {
          this.PreLoader = false;
        }
      }, error => {
        this.PreLoader = false;
      });
    }
  }

}
